import websiteLogo from '../assets/website.png';
import admissionsLogo from '../assets/admissions.png';
import recruitmentLogo from '../assets/recruitment.png';
import fioriLogo from '../assets/FIORI.png';
import careerConnectLogo from '../assets/aror_cc.jpg';
import cbtLogo from '../assets/CBT.png';
import leaveLogo from '../assets/leave approval.png';
import ghouseLogo from '../assets/ghouse.png';
import dirLogo from '../assets/aror_dir.png';
import submitLogo from '../assets/submitapplogo.png';
import blackboardLogo from '../assets/blackboard.png';
import turnitinLogo from '../assets/turintin.png';
import officeLogo from '../assets/office.png';
import kohaLogo from '../assets/koha.png';
import ebookLogo from '../assets/ebook.png';
import hecLogo from '../assets/heclibrary.png';
import aliLogo from '../assets/ali.png';
import aurjLogo from '../assets/aurj.jpg';

export const CATEGORIES = [
  { id: 'all', label: 'All Apps' },
  { id: 'university', label: 'University' },
  { id: 'academic', label: 'Academic' },
  { id: 'admin', label: 'Administration' },
  { id: 'library', label: 'Library' },
  { id: 'mobile', label: 'Mobile' },
];

export const apps = [
  {
    id: 1,
    name: 'Official Website',
    url: 'https://aror.edu.pk',
    logo: websiteLogo,
    description: 'Visit the official AROR University website',
    category: 'university',
    isLocal: false,
  },
  {
    id: 2,
    name: 'Admission Portal',
    url: 'https://admissions.aror.edu.pk',
    logo: admissionsLogo,
    description: 'Apply for admissions to AROR University',
    category: 'university',
    isLocal: false,
  },
  {
    id: 3,
    name: 'Recruitment Portal',
    url: 'https://recruitment.aror.edu.pk',
    logo: recruitmentLogo,
    description: 'Career opportunities at AROR University',
    category: 'university',
    isLocal: false,
  },
  {
    id: 4,
    name: 'SAP FIORI Portal',
    url: 'https://fiori.maktab.pern.edu.pk:8000/sap/bc/ui5_ui5/ui2/ushell/shells/abap/FioriLaunchpad.html',
    logo: fioriLogo,
    description: 'Enterprise resource planning system',
    category: 'academic',
    isLocal: false,
  },
  {
    id: 19,
    name: 'Aror Career Connect',
    url: 'https://careerconnect.aror.edu.pk/',
    logo: careerConnectLogo,
    description: 'Student placement and industry linkages platform',
    category: 'university',
    isLocal: false,
  },
  {
    id: 5,
    name: 'CBT Portal',
    url: 'https://cbt.aror.edu.pk',
    logo: cbtLogo,
    description: 'Computer Based Testing System',
    category: 'academic',
    isLocal: false,
  },
  {
    id: 6,
    name: 'Aror Access System',
    url: 'https://access.aror.edu.pk',
    logo: leaveLogo,
    description: 'Manage and approve leave requests',
    category: 'admin',
    isLocal: true,
  },
  {
    id: 7,
    name: 'Aror Access — Android',
    apkFile: process.env.PUBLIC_URL + '/apk/aror-access-system.apk',
    logo: leaveLogo,
    description: 'Leave approval mobile app for Android',
    category: 'mobile',
    isLocal: false,
    isAndroidApp: true,
  },
  {
    id: 8,
    name: 'Guest House Management',
    url: 'http://hostel.aror.edu.pk',
    logo: ghouseLogo,
    description: 'Guest house booking and management',
    category: 'admin',
    isLocal: true,
  },
  {
    id: 9,
    name: 'AROR Directory System',
    url: 'http://10.10.30.8',
    logo: dirLogo,
    description: 'University directory and file management',
    category: 'admin',
    isLocal: true,
  },
  {
    id: 10,
    name: 'AROR Submit App',
    url: 'http://10.10.30.8/submit/login',
    logo: submitLogo,
    description: 'Submit applications and documents',
    category: 'admin',
    isLocal: true,
  },
  {
    id: 11,
    name: 'Blackboard LMS',
    url: 'https://lms.aror.edu.pk/',
    logo: blackboardLogo,
    description: 'Learning Management System',
    category: 'academic',
    isLocal: false,
  },
  {
    id: 12,
    name: 'Turnitin',
    url: 'https://turnitin.com',
    logo: turnitinLogo,
    description: 'Plagiarism detection and academic integrity',
    category: 'academic',
    isLocal: false,
  },
  {
    id: 13,
    name: 'Office 365',
    url: 'https://office.com',
    logo: officeLogo,
    description: 'Microsoft Office suite and productivity tools',
    category: 'admin',
    isLocal: false,
  },
  {
    id: 14,
    name: 'Koha Library System',
    url: 'https://library-iportal.aror.edu.pk:9087/',
    logo: kohaLogo,
    description: 'Library management system',
    category: 'library',
    isLocal: false,
  },
  {
    id: 15,
    name: 'E-Book Library Portal',
    url: 'http://10.10.68.9:8080/',
    logo: ebookLogo,
    description: 'E-Book library — campus network only',
    category: 'library',
    isLocal: true,
  },
  {
    id: 16,
    name: 'HEC Digital Library',
    url: 'http://www.digitallibrary.edu.pk/aror.html',
    logo: hecLogo,
    description: 'Higher Education Commission Digital Library',
    category: 'library',
    isLocal: false,
  },
  {
    id: 17,
    name: 'Aror Learning Institute',
    url: 'https://ali.aror.edu.pk/',
    logo: aliLogo,
    description: 'Aror Learning Institute',
    category: 'university',
    isLocal: false,
  },
  {
    id: 18,
    name: 'Aror Research Journal',
    url: 'https://aurj.aror.edu.pk/index.php/AURJ',
    logo: aurjLogo,
    description: 'Aror University Research Journal',
    category: 'university',
    isLocal: false,
  },
];
